// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Spørg Amigo',
    assistant: 'Assistent',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Spørg Amigo, nye: {{count}}',
    amigo_other: 'Spørg Amigo, nye: {{count}}',
    assistant_one: 'Assistent, nye: {{count}}',
    assistant_other: 'Assistent, nye: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo er ikke tilgængelig',
    assistant: 'Assistent ikke tilgængelig',
  },
  unavailable_text: {
    amigo: 'Amigo er ikke tilgængelig lige nu.',
    assistant: 'Assistenten er ikke tilgængelig lige nu.',
  },
};
